import { Checkbox, Typography } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'

import { getTranslate } from '../../localization'
import { BookingPermission } from '../../types/bookingPermission'
import useStyles from './styles/BookingPermissionTableRow'

type BookingPermissionTableRowProps = {
  item: BookingPermission
  isOdd: boolean
  editMode: boolean
  setData: React.Dispatch<React.SetStateAction<BookingPermission[]>>
}

const BookingPermissionTableRow = ({
  item,
  isOdd,
  editMode,
  setData
}: BookingPermissionTableRowProps) => {
  const classes = useStyles()

  const CheckIconFunc = () => {
    return <CheckIcon className={classes.checkIcon} />
  }

  const CloseIconFunc = () => {
    return <CloseIcon className={classes.closeIcon} />
  }

  return (
    <div className={[classes.tableRow, isOdd && classes.tableRowOdd].join(' ')}>
      <div>
        <Typography variant="body1">{item.accommodationName}</Typography>
      </div>
      <div>
        <Typography variant="body1">{item.reservationType}</Typography>
      </div>
      <div>
        <Typography variant="body1">{item.channelType}</Typography>
      </div>
      <div>
        <Typography variant="body1">
          {getTranslate(item.actionType || '')}
        </Typography>
      </div>
      {editMode ? (
        <div className={classes.CheckBoxContainer}>
          <Checkbox
            checked={item.allowOperation}
            onChange={() => {
              setData((prevData) =>
                prevData.map((row) =>
                  row.reservationType === item.reservationType &&
                  row.accommodationId === item.accommodationId
                    ? { ...row, allowOperation: !row.allowOperation }
                    : row
                )
              )
            }}
            color="primary"
            classes={{
              root: classes.checkBoxPadding
            }}
          />
        </div>
      ) : (
        <Typography variant="body1">
          {item.allowOperation ? CheckIconFunc() : CloseIconFunc()}
        </Typography>
      )}
      {editMode ? (
        <div className={classes.CheckBoxContainer}>
          <Checkbox
            checked={item.allowDiscount}
            onChange={() => {
              setData((prevData) =>
                prevData.map((row) =>
                  row.reservationType === item.reservationType &&
                  row.accommodationId === item.accommodationId
                    ? { ...row, allowDiscount: !row.allowDiscount }
                    : row
                )
              )
            }}
            color="primary"
            classes={{
              root: classes.checkBoxPadding
            }}
          />
        </div>
      ) : (
        <Typography variant="body1">
          {item.allowDiscount ? CheckIconFunc() : CloseIconFunc()}
        </Typography>
      )}
    </div>
  )
}

export default BookingPermissionTableRow
